const initializeNestwistProductGallery = (root = document) => {
  root.querySelectorAll('[data-nestwist-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.initialized === 'true') return;

    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const choices = Array.from(gallery.querySelectorAll('[data-gallery-target]'));
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');

    if (!track || slides.length < 2) return;
    gallery.dataset.initialized = 'true';

    let activeIndex = 0;
    let pointerStartX = null;

    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        if (isActive) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      choices.forEach((choice, choiceIndex) => {
        const isActive = choiceIndex === activeIndex;
        choice.classList.toggle('is-active', isActive);
        if (isActive) {
          choice.setAttribute('aria-current', 'true');
        } else {
          choice.removeAttribute('aria-current');
        }
      });

      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
    };

    const goTo = (index) => {
      setActive(index);
    };

    choices.forEach((choice) => {
      choice.addEventListener('click', () => goTo(Number(choice.dataset.galleryTarget)));
    });

    previous?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));

    track.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary) return;
      pointerStartX = event.clientX;
    });

    track.addEventListener('pointerup', (event) => {
      if (pointerStartX === null || !event.isPrimary) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 40) return;
      goTo(distance < 0 ? activeIndex + 1 : activeIndex - 1);
    });

    track.addEventListener('pointercancel', () => { pointerStartX = null; });
    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') goTo(activeIndex - 1);
      if (event.key === 'ArrowRight') goTo(activeIndex + 1);
    });

    setActive(0);
  });
};

initializeNestwistProductGallery();
document.addEventListener('shopify:section:load', (event) => initializeNestwistProductGallery(event.target));
